<template>
  <v-footer class="footerContainer" padless>
    <div class="backButton" v-if="isBack" @click="goPrevious">
      <span>
        <img src="@/assets/icons/back.svg" alt="" />
      </span>
    </div>
    <nav class="gnav" :class="{ hide: !isGnav }">
      <router-link
        class="gnav-item menu-0"
        :class="{ active: $route.meta.gnavGroup === 'materials' }"
        to="/materials"
        >さがす</router-link
      >
      <router-link
        class="gnav-item menu-1"
        :class="{ active: $route.meta.gnavGroup === 'scan' }"
        to="/scan"
        >スキャンする</router-link
      >
      <router-link
        class="gnav-item menu-2"
        :class="{ active: $route.meta.gnavGroup === 'user-detail' }"
        :to="
          auth
            ? { name: 'user-detail', params: { id: auth.username } }
            : { name: 'login' }
        "
        >マイ材木</router-link
      >

      <div class="gnav-bg"></div>
    </nav>
    <p v-if="$route.meta.gnavGroup != 'scan'">
      © {{ new Date().getFullYear() }} VUILD, Inc.
    </p>
    <div class="terms-and-privacy" v-if="$route.meta.gnavGroup != 'scan'">
      <a href="https://emarf.co/terms/">利用規約</a
      ><a href="https://emarf.co/policy/">プライバシーポリシー</a>
    </div>
  </v-footer>
</template>
<script>
import gsap from "gsap";
export default {
  components: {},
  data() {
    return {
      currentMenu: 0,
      menus: [
        {
          name: "materials",
          path: "/materials",
        },
        {
          name: "scan",
          path: "/scan",
        },
        {
          name: "user-detail",
          path: "/user/:id",
        },
      ],
      isDebug: false,
    };
  },
  computed: {
    isBack() {
      return this.$route.meta.isBack;
      // return this.$route.name === "material-edit" ||
      //   this.$route.name === "user-edit" ||
      //   (this.$route.name === "user-detail" &&
      //     !(this.$route.params.id === this.auth.username)) ||
      //   this.$route.name === "material-detail" ||
      //   this.$route.name === "confirm" ||
      //   this.$route.name === "password-forgot" ||
      //   this.$route.name === "password-reset" ||
      //   this.$route.name === "locations" ||
      //   this.$route.name === "location-add" ||
      //   this.$route.name === "signup" ||
      //   this.$route.name === "login"
      //   ? true
      //   : false;
    },

    isGnav() {
      return this.$route.meta.isGnav;
      // return this.$route.name === "scan" ||
      //   this.$route.name === "materials" ||
      //   this.$route.name === "material-detail" ||
      //   this.$route.name === "user-detail" ||
      //   this.$route.name === "locations"
      //   ? true
      //   : false;
    },
    auth() {
      return this.$store.state.auth.authUser;
    },
  },
  methods: {
    goPrevious() {
      this.$router.back();
    },
    //GSAP animation pattern
    moveBg(i) {
      gsap.to(".gnav-bg", {
        x: i * (82 + 4),
        duration: 0.2,
        ease: "power3.inOut",
      });
    },
    switchClass(i) {
      this.currentMenu = i;
    },
  },
  watch: {
    $route(to) {
      this.menus.forEach((menu, i) => {
        if (menu.name === to.meta.gnavGroup) {
          this.moveBg(i);
          this.switchClass(i);
        } else {
          return;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.footerContainer {
  display: block;
  bottom: 0;
  flex: none;
  padding: 0;
  width: 100%;
  /* margin: auto; */
  // keep space for gnav
  margin: 32px 0 128px;
  background: transparent;
  @include zIndex(ev8);
  p {
    width: 100%;
    text-align: center;
    @include caption();
    color: $contentsDarkHigh;
    margin: 0;
  }
}
.terms-and-privacy {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  a {
    @include caption();
    color: $contentsDarkMiddle;
    margin: 0 8px;
  }
}

.backButton {
  position: fixed;
  bottom: 32px;
  left: calc(100vw / 2 - 640px / 2);
  cursor: pointer;
  @include zIndex(ev8);
  @include mq(mdsp) {
    left: 8px;
  }
  @include mq(sp) {
    bottom: 34px;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 56px;
    background-color: $surfaceDark;
    box-shadow: 0px 9px 25px rgba(80, 71, 62, 0.27),
      0px 2.71324px 7.53677px rgba(80, 71, 62, 0.175929),
      0px 1.12694px 3.13039px rgba(80, 71, 62, 0.135),
      0px 0.407592px 1.1322px rgba(80, 71, 62, 0.094071);
    border-radius: 20px;

    img {
      width: 32px;
      height: 32px;
    }
    @include mq(sp) {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }
  }
}

.gnav {
  &.hide {
    display: none;
  }
  position: fixed;
  display: flex;
  gap: 4px;
  flex-direction: row;
  padding: 4px;
  background-color: $surfaceDark;
  border-radius: 40px;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
}
.gnav-item {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 2px;
  width: 82px;
  padding: 0.25rem 0.375rem;
  color: $contentsLightHigh;
  text-decoration: none;
  @include overline();
  font-weight: bold;
  @include zIndex(ev4);
  @include animationCurve(hover);
  &.menu-0:before {
    background-image: url("@/assets/icons/search-light.svg");
    @include animationCurve(hover);
  }
  &.menu-1:before {
    background-image: url("@/assets/icons/scan-light.svg");
    @include animationCurve(hover);
  }
  &.menu-2:before {
    background-image: url("@/assets/icons/my-light.svg");
    @include animationCurve(hover);
  }
  &.active {
    color: $contentsDarkHigh;
  }
  &.menu-0.active:before {
    background-image: url("@/assets/icons/search-dark.svg");
  }
  &.menu-1.active:before {
    background-image: url("@/assets/icons/scan-dark.svg");
  }
  &.menu-2.active:before {
    background-image: url("@/assets/icons/my-dark.svg");
  }
  &:before {
    margin: 0 auto;
    content: "";
    width: 24px;
    height: 24px;
  }
}
.gnav-bg {
  background-color: $surfaceWhite;
  border-radius: 30px;
  position: absolute;
  height: calc(100% - 4 * 2px);
  width: 82px;
  @include zIndex(ev0);
}
</style>
